module.exports = __webpack_public_path__ + "img/effet-points-colonne-4.ee2f5760.png";